<template>
  <a
    :href="shareUrl"
    target="_blank"
  >
    <i class="icon-linkedin" />
  </a>
</template>

<script>
import ENVIRONMENT from '@/env';

export default {
  name: 'ButtonLinkedin',

  props: {
    article: {
      type: Object,
      required: true,
      default: null
    }
  },

  computed: {
    hashtags() {
      return this.article.tags.replace(' | ', ',');
    },

    baseUrl() {
      return ENVIRONMENT.baseUrl;
    },

    articleUrl() {
      return `${this.baseUrl}/blog/${this.article.slug}`;
    },

    shareUrl() {
      return encodeURI(`https://www.linkedin.com/shareArticle?\
&url=${this.articleUrl}\
&title=${this.article.title}\
&summary=${this.article.smallTitle}`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// button-linkedin.vue